<app-item [detailIcon]="false" lines="none" [icon]="icon">
  @if (client?.profileImage && client?.profileImage !== '') {
    <app-avatar [src]="client?.profileImage" (click)="handleDeleteProfilePicture(client?.id)"></app-avatar>
  }

  <ion-label>
    <h3>{{ client?.name }} {{ client?.surname1 }} {{ client?.surname2 }}</h3>
    @if (showContactData) {
      <p> {{ 'lbl_phone_abbrev' | translate }} {{ client?.phone }} </p>
    }
    @if (client?.profileImage && client?.profileImage !== '' && clientAge !== null) {
      <p>{{ 'lbl_age' | translate }} {{ clientAge }}</p>
    }
  </ion-label>
</app-item>
